import { Component, OnInit,LOCALE_ID, Inject } from '@angular/core';
import { PageService } from '../page.service';
import { PageItem } from '../page';
import { ActivatedRoute } from "@angular/router";
import { Meta } from '@angular/platform-browser';
import { Title }     from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  pages : PageItem[];
  homeImage = "industria-paisaia.svg"

  constructor(
    private route: ActivatedRoute,
    private pageService: PageService,
    @Inject(LOCALE_ID) public localeId: string,
    private titleService: Title,
    private meta: Meta,
  )
  {
        // this.route.params.subscribe( params => console.log(params.id) );
  }

  ngOnInit() {
		// console.log(this.localeId);
    if (this.localeId==='es') this.homeImage = "industria-paisaia.es.svg";
    else if (this.localeId==='eu') this.homeImage = "industria-paisaia.svg";
    // this.pageService.getItems();
    this.pageService.getParentPages()
      .subscribe(data => {
        this.pages = data;
        //this.pageService.currentPage
      });

      let title = "Industria Paisaia"
      this.titleService.setTitle(title);
  }

}
